<style scoped lang="scss">

</style>

<template>
    <div>
        <div class="uk-form" v-if="application">
            <h3 class="instructions"><em>Instructions: Please <strong>read this page</strong> and <strong>sign and
                date</strong> to acknowledge you understand the terms and conditions of applying for and receiving
                assistance from {{ application.program.program_name }}.</em></h3>
            <hr/>
            <fieldset data-uk-margin>
                <h4>Privacy and protection of personal information</h4>
                <ol>
                    <li>I understand that the submission of an application does not guarantee {{ application.program.program_name }} assistance.</li>
                    <li>I hereby authorize the housing counselors and their employees to discuss, share, release and otherwise provide to the {{ application.program.agency_name }} information about my credit and , rental or mortgage history, employment, and financial and rent or mortgage situation as it is necessary to seek solutions to my housing and/or utility problem.</li>
                    <li>I understand that this information will be treated as confidential and that access to this information will be limited to those who are directly involved in assisting with my application.</li>
                    <li>I understand the {{ application.program.agency_name }} may provide certain information not covered under applicable privacy laws to be reported to the United States Department of the Treasury or its successors or assigns for limited reporting purposes related to federal housing programs.</li>
                    <li>I certify that I have received a copy of the {{ application.program.agency_name }}'s Privacy Policy.</li>
                    <li>I consent to being contacted concerning this request for rental or mortgage assistance at any mobile telephone number or email address I have provided. This includes email addresses, text messages, and telephone calls to my mobile telephone.</li>
                    <li>I/we understand that participation in {{ application.program.program_name }} may negatively impact my/our credit score(s).</li>
                    <li>I/we understand that participation in certain programs in 2014 or later could have tax consequences if the Mortgage Forgiveness Debt Relief Act expires.</li>
                </ol>
                <h4>Application process</h4>
                <ol>
                    <li>I understand that I do not automatically qualify for {{ application.program.program_name }} assistance by submitting an application or any additional forms or documents requested by {{ application.program.agency_name }} or their assignees. the housing counselor or the {{ application.program.agency_name }}.</li>
                    <li>I understand that this is only an application for assistance and that the {{ application.program.agency_name }} or its assignees will consider additional underwriting factors in reviewing my application.</li>
                    <li>I understand that my application may not meet applicable underwriting criteria and that I will be notified in writing via mail, email, or through the online application, of my application's acceptance or denial.</li>
                    <li>I certify that I am willing to provide all requested documents and to respond to all communications from the  {{ application.program.agency_name }}  and its partners in a timely manner.</li>
                    <li>I understand that if I am approved for assistance from {{ application.program.agency_name }}, my participation and any assistance received is based on my continued eligibility and my agreeing to meet the guidelines and terms and conditions of the program and certain other criteria.</li>
                    <li>I authorize the  {{ application.program.agency_name }} or its assignees to review and verify information contained in my {{ application.program.program_name }} application at any time, including, but not limited to, during after and quality control.</li>
                    <li>I authorize the counseling agency, if used,  to provide the {{ application.program.agency_name }}, or its authorized agents and assigns, any and all information and documentation they request.</li>
                    <li>I understand that I may be audited by the {{ application.program.agency_name }} or its assignees and agree to provide requested documents in a timely manner or risk termination or repayment of my assistance.</li>
                </ol>
                <h4>Fraud</h4>
                <ol>
                    <li>I certify that my mortgaged property has not received a condemnation notice.</li>
                    <li>I have described my current financial condition, and certify that all information presented herein, as well as attachments are true, accurate, and correct to the best of my knowledge.</li>
                    <li>I understand that false or misleading information will affect my ability to receive assistance and may be grounds for rejection of my application or termination of assistance I may receive.</li>
                    <li>I understand that false or misleading information may result in a request for immediate repayment of any assistance that I receive.</li>
                    <li>I/we also understand that knowingly submitting false information may violate Federal law.</li>
                </ol>

                <div class="uk-container uk-margin-top">
                    <div class="uk-grid">
                        <div class="uk-panel uk-panel-box uk-width-1-1"><span class="uk-panel-title"><i
                                class="uk-icon-exclamation-circle uk-icon-large theme-primary-color"></i>
                            <u>Disclaimer/limitation of liability</u></span>
                            <div class="uk-panel-body">
                                You agree to defend, indemnify and hold harmless {{ application.program.agency_name }} and its
                                assignees ("Agency") and its affiliates, subsidiaries,
                                agents, and their respective officers, directors, employees, and agents from and against
                                all claims, liabilities, costs, and expenses arising from your utilizing a participating
                                housing counselor and/or any representation or warranty made by the Agency; your failure
                                to comply with the Terms and Conditions' your negligence, actions, or omissions; your
                                violation or alleged violation of the rights of a third party.

                                Under no circumstances will {{ application.program.agency_name }} or its assignees or the {{ application.program.program_name }} program be liable for any lost profits, lost
                                opportunity or any direct, consequential, incidental, special, punitive, or exemplary
                                damages arising out of your use of or inability to use Agency services or programs, even
                                if the Agency has been apprised of the likelihood of such damages occurring and
                                regardless of the form of action, whether in contract, warranty, tort (including
                                negligence), strict liability, or otherwise. This includes any damages or losses based
                                on any statement, representation, negligence, action, or omission by any housing
                                counselor or their employees or their agents.
                            </div>
                        </div>
                    </div>
                </div>
                <p>&nbsp;</p>
                <div class="uk-container uk-margin-top">
                    <div class="uk-grid">
                        <div class="uk-width-1-1">
                            <h3 class="uk-text-center instructions"
                                style="border-bottom:1px solid #dedede;margin-bottom:2em;padding-bottom:1em;"><em>The
                                following information is requested by the federal government in accordance with the
                                Dodd-Frank Wall Street Reform and Consumer Protection Act (Pub. L. 111-203). You are
                                required to furnish this information.</em></h3>
                        </div>

                        <div class="uk-width-1-1 uk-grid uk-margin-large-bottom" v-if="application.household">
                            <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2" v-for="member in application.household.members">
                                <div v-if="member.age >= 18">
                                    <div class="uk-width-medium-1-1">
                                        <legend>{{ member.first_name }} {{ member.last_name }}</legend>
                                        <p>
                                            <validated-section :errors="errors" :field="'conviction_'+member.id">
                                                <label>
                                                    <input type="checkbox"
                                                           :checked="signatureData[member.id] && signatureData[member.id].disclaimer_conviction_checked_at"
                                                           @change="onCheckboxUpdated(member.id, 'disclaimer_conviction_checked_at', $event.target.checked)">
                                                    I certify that I have not been convicted, within the last ten (10) years of any of the
                                                    following in connection with a mortgage or real estate transaction: (a) felony larceny,
                                                    theft, fraud or forgery, (b) money laundering; or (c) tax evasion.
                                                </label>
                                            </validated-section>

                                        </p>
                                        <p style="margin-bottom:2em;">
                                            <validated-section :errors="errors" :field="'background_'+member.id">
                                                <label><input :checked="signatureData[member.id] && signatureData[member.id].disclaimer_background_checks_checked_at"
                                                              type="checkbox"
                                                              @change="onCheckboxUpdated(member.id, 'disclaimer_background_checks_checked_at', $event.target.checked)">
                                                    I certify that I understand that the Servicer, {{ application.program.agency_name }}, the
                                                    State of {{ application.program.state }}, the U.S. Department of Treasury, or their
                                                    agents may investigate the accuracy of my statements by performing routine background
                                                    checks, including automated searches of federal, state and county databases, to confirm
                                                    that I have not been convicted of such crimes.</label>
                                            </validated-section>
                                        </p>
                                        <p style="margin-bottom:2em;">
                                            <validated-section :errors="errors" :field="'dodd_'+member.id">
                                                <label><input :checked="signatureData[member.id] && signatureData[member.id].disclaimer_dodd_frank_checked_at"
                                                              type="checkbox"
                                                              @change="onCheckboxUpdated(member.id, 'disclaimer_dodd_frank_checked_at', $event.target.checked)">
                                                    I certify that I am applying for rent or utility assistance and am not
                                                    required to certify under the Dodd-Frank Wall Street Reform and Consumer
                                                    Protection Act. </label>
                                            </validated-section>
                                        </p>

                                        <validated-section :errors="errors" :field="'signature_'+member.id">
                                            <signature-box @updated="onSignatureUpdated"
                                               :user-key="member.id"
                                               :is-signed="signatureData[member.id] && signatureData[member.id].disclaimer_signed_at"
                                               :completed="signatureData[member.id] && signatureData[member.id].completed"
                                               :name="member.first_name + ' ' + member.last_name"
                                               :color="programSettings['primary-program-color']"
                                               ref="signatureBox"
                                            ></signature-box>
                                        </validated-section>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>

        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters} from 'vuex';
    import SignatureBox from "../../../../../components/AppWizard/SignatureBox";
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";
    export default {
        name: "Step6",
        components: {ValidatedSection, SignatureBox},
        data() {
            return {
                signatureData: {},
                errors: {},
            }
        },
        computed: {
            ...mapState('Application', {
                application: state => state.application,
                signatures: state => state.signatures,
            }),
            ...mapGetters('Application', [ 'programSettings' ])
        },
        watch: {
            application(newValue) {
                if(newValue.household) {
                    this.initData();
                }
            }
        },
        mounted() {
            if(this.application) this.initData();
        },
        methods: {
            initData() {
                _.each(this.application.household.members, member => {
                    if(member.age >= 18) {
                        const signatureFiltered = member.signatures.find(item => item.key === `app-terms-conditions`)
                        if(signatureFiltered) {
                            this.$set(this.signatureData, member.id, {
                                disclaimer_signed_at: signatureFiltered.created_at,
                                disclaimer_conviction_checked_at: signatureFiltered.created_at,
                                disclaimer_background_checks_checked_at: signatureFiltered.created_at,
                                disclaimer_dodd_frank_checked_at: signatureFiltered.created_at,
                                completed: true,
                            })
                        }
                    }
                })
            },
            onCheckboxUpdated(memberId, field, checked) {
                if(!this.signatureData[memberId]) {
                    this.$set(this.signatureData, memberId, {});
                }
                this.$set(this.signatureData[memberId], field, checked ? moment().format('YYYY-MM-DD HH:mm') : null);
            },
            onSignatureUpdated($event) {
                if(!this.signatureData[$event.key]) {
                    this.$set(this.signatureData, $event.key, {});
                }
                this.$set(this.signatureData[$event.key], 'disclaimer_signed_at', $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null);
            },
            async validateStep() {
                this.errors = {};
                // Local Validation
                _.each(this.application.household.members, (member) => {
                    if(member.age >= 18) {
                        if(!this.signatureData[member.id] || !this.signatureData[member.id].disclaimer_signed_at) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }

                        if(!this.signatureData[member.id] || !this.signatureData[member.id].disclaimer_conviction_checked_at) {
                            this.errors['conviction_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must agree.'],
                            };
                        }

                        if(!this.signatureData[member.id] || !this.signatureData[member.id].disclaimer_background_checks_checked_at) {
                            this.errors['background_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must agree.'],
                            };
                        }

                        if(!this.signatureData[member.id] || !this.signatureData[member.id].disclaimer_dodd_frank_checked_at) {
                            this.errors['dodd_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must agree.'],
                            };
                        }
                    }
                })

                console.log(this.errors)
                let errorCount = _.size(this.errors);

                if(errorCount > 0) return false;

                // Server Side Validation
                try {
                    let response = await this.save();
                    return true;
                }catch(err) {
                    console.error(err);
                }
            },
            save() {
                let data = {
                    signatures: this.signatureData,
                }
                return axios.put(`/api/hope/applications/${this.application.id}/step-6`, data)
            }
        }
    }
</script>
